export const dark = {
    baseBrand50: "#322447",
    baseBrand100: "#3d2c56",
    baseBrand200: "#543680",
    baseBrand300: "#724ea7",
    baseBrand400: "#9167cd",
    baseBrand500: "#af80f4",
    baseBrand600: "#bf99f6",
    baseBrand700: "#cfb3f8",
    baseBrand800: "#dfccfb",
    baseBrand900: "#e7d9fc",
    baseSteel50: "#38393d",
    baseSteel100: "#313235",
    baseSteel200: "#494b50",
    baseSteel300: "#57585c",
    baseSteel400: "#95989d",
    baseSteel500: "#c9cbcf",
    baseSteel600: "#d1d3d6",
    baseSteel700: "#dfe0e2",
    baseSteel800: "#f7f8f9",
    baseSteel900: "#ffffff",
    baseGray50: "#070708",
    baseGray100: "#0e0e0f",
    baseGray200: "#2b2b2e",
    baseGray300: "#1b1c1e",
    baseGray400: "#2e2f33",
    baseGray500: "#36353b",
    baseGray600: "#414045",
    baseGray700: "#504f54",
    baseGray800: "#6f6e74",
    baseGray900: "#838288",
    baseBlue50: "#000b19",
    baseBlue100: "#152e51",
    baseBlue200: "#1d3a63",
    baseBlue300: "#3663a1",
    baseBlue400: "#4880cf",
    baseBlue500: "#5a9dfc",
    baseBlue600: "#7bb1fd",
    baseBlue700: "#9cc4fd",
    baseBlue800: "#bdd8fe",
    baseBlue900: "#deebfe",
    baseGreen50: "#03110b",
    baseGreen100: "#0b412b",
    baseGreen200: "#0f5235",
    baseGreen300: "#16784f",
    baseGreen400: "#1d9b66",
    baseGreen500: "#23bd7d",
    baseGreen600: "#41c890",
    baseGreen700: "#5fd2a3",
    baseGreen800: "#7eddb5",
    baseGreen900: "#abedd2",
    baseRed50: "#230001",
    baseRed100: "#4f1618",
    baseRed200: "#7b2d2f",
    baseRed300: "#a74345",
    baseRed400: "#d35a5c",
    baseRed500: "#ff7073",
    baseRed600: "#ff8d8f",
    baseRed700: "#ffa9ab",
    baseRed800: "#ffc6c7",
    baseRed900: "#ffe2e3",
    baseYellow50: "#1c0f03",
    baseYellow100: "#512f10",
    baseYellow200: "#603915",
    baseYellow300: "#995d25",
    baseYellow400: "#c37730",
    baseYellow500: "#ed913b",
    baseYellow600: "#f1a762",
    baseYellow700: "#f4bd89",
    baseYellow800: "#f8d3b1",
    baseYellow900: "#fbe9d8",
    baseMagenta50: "#220012",
    baseMagenta100: "#4e1432",
    baseMagenta200: "#7a2751",
    baseMagenta300: "#a53b71",
    baseMagenta400: "#d14e90",
    baseMagenta500: "#fd62b0",
    baseMagenta600: "#fd81c0",
    baseMagenta700: "#fea1d0",
    baseMagenta800: "#fec0df",
    baseMagenta900: "#fed0e7",
    interactivePrimaryDefault: "#af80f4",
    interactivePrimaryActive: "#af80f4",
    interactivePrimaryHover: "#bf99f6",
    interactivePrimaryPressed: "#cfb3f8",
    interactivePrimaryDisabled: "#724ea7",
    interactiveSuccessDefault: "#23bd7d",
    interactiveSuccessHover: "#41c890",
    interactiveSuccessPressed: "#5fd2a3",
    interactiveSuccessActive: "#5fd2a3",
    interactiveSuccessDisabled: "#16784f",
    interactiveWarningDefault: "#ed913b",
    interactiveWarningHover: "#f1a762",
    interactiveWarningPressed: "#f4bd89",
    interactiveWarningDisabled: "#995d25",
    interactiveCriticalDefault: "#ff7073",
    interactiveCriticalHover: "#ff8d8f",
    interactiveCriticalPressed: "#ffa9ab",
    interactiveCriticalDisabled: "#a74345",
    interactiveInfoDefault: "#5a9dfc",
    interactiveInfoHover: "#7bb1fd",
    interactiveInfoPressed: "#9cc4fd",
    interactiveInfoDisabled: "#3663a1",
    interactiveNeutralDefault: "#2e2f33",
    interactiveNeutralHover: "#36353b",
    interactiveNeutralPressed: "#414045",
    interactiveNeutralDisabled: "#504f54",
    backgroundViewDarker: "#38393d",
    backgroundViewHoverBackground: "#322447",
    backgroundViewLighter: "#0e0e0f",
    backgroundViewLight: "#2b2b2e",
    backgroundViewApp: "#1b1c1e",
    backgroundViewHover: "#2e2f33",
    backgroundViewNavi: "#36353b",
    backgroundViewEdit: "#322447",
    backgroundViewAppshell: "#1b1c1e",
    backgroundSystemInfoLight: "#012032",
    backgroundSystemInfoDefault: "#152e51",
    backgroundSystemCritcal: "#4f1618",
    backgroundSystemWarning: "#512f10",
    backgroundSystemSuccess: "#0b412b",
    backgroundPrivateDefault: "#2d2c23",
    backgroundPrivateLight: "#25241d",
    backgroundPrivateDark: "#343228",
    backgroundGradientBrand: "linear-gradient(270deg, #078FE4 0%, #163EA2 100%)",
    backgroundGradientNeutral: "linear-gradient(180deg, #222326 0%, #1d1d20 100%)",
    backgroundGradientLead: "linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)",
    backgroundGradientScale: "linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)",
    backgroundGradientLaunch: "linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)",
    backgroundGradientPurple: "linear-gradient(-90deg, #C177D5 30%, #653EAC 70%)",
    backgroundGradientOrange: "linear-gradient(90deg, #C45A03 27.46%, #EEAF0C 100%)",
    backgroundGradientRed: "linear-gradient(90deg, #F9062B 27.46%, #FFDBD4 100%)",
    backgroundGradientLightBlue: "linear-gradient(45deg, #0789D9 0%, #62C2F9 100%)",
    backgroundGradientVideo: "linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)",
    backgroundGradientVideoOverlay: "linear-gradient(45deg, rgba(23, 66, 152, 0.7) 0%, rgba(113, 72, 189, 0.7) 52%, rgba(175, 126, 230, 0.7) 100%)",
    backgroundGradientFindTimeGray: "repeating-linear-gradient(135deg, #303236, #303236 6px, #484A51 6px, #484A51 12px)",
    backgroundGradientFindTimeBlue: "repeating-linear-gradient(135deg, #362252, #362252 6px, #4B336F 6px, #4B336F 12px)",
    backgroundGradientFindTimeViolet: "repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)",
    backgroundGradientMask: "linear-gradient(-60deg, #e8198a 30%, #e8198a5, #e8198a 70%) right/300% 100%",
    backgroundGradientRainbow: "linear-gradient(90deg, rgb(90, 55, 154) 0%, rgb(184, 99, 207) 7%, rgb(20, 121, 179) 14%, rgb(73, 184, 248) 21%, rgb(85, 199, 82) 27%, rgb(39, 150, 118) 33.33%, rgb(104, 205, 101) 36%, rgb(98, 194, 249) 42%, rgb(22, 136, 202) 47%, rgb(193, 119, 213) 53%, rgb(101, 62, 172) 60%, rgb(22, 136, 202) 66.66%, rgb(98, 194, 249) 100%)",
    backgroundGradientGrayToTransparent: "linear-gradient(to bottom, rgba(29, 30, 32, 1) 0%, rgba(29, 30, 32, 0) 100%)",
    backgroundGradientTellentDefault: "linear-gradient(90deg, #681D74 0%, #230AC0 100%)",
    backgroundGradientTellentPink: "linear-gradient(90deg, #af80f4 0%, #fd62b0 100%)",
    backgroundGradientTellentLightPurple: "linear-gradient(90deg, #48257D 0%, #3B2F4E 100%)",
    backgroundGradientAiLightPurple: "linear-gradient(90deg, #48257D 0%, #3B2F4E 100%)",
    backgroundGradientAiLightPurpleMagenta: "linear-gradient(-90deg, #372C3E 0%, #332D41 100%)",
    backgroundGradientAiPurpleMagenta: "linear-gradient(-90deg, #633068 0%, #383262 100%)",
    backgroundGradientAiDarkPurpleMagenta: "linear-gradient(-90deg, #EDC2E1 0%, #DABFF5 100%)",
    backgroundGradientAiDarkPurpleViolet: "linear-gradient(90deg, #803A94 0%, #773A98 25%, #723B9B 50%, #6A3A9E 75%, #643BA1 100%)",
    backgroundGradientGrowDefault: "linear-gradient(90deg, #BDA4E2 0%, #36116E 100%)",
    backgroundGradientWorkflowsDefault: "linear-gradient(180deg, rgba(255, 153, 85, 1) 0%, rgba(253, 98, 176, 1) 50%, rgba(175, 128, 244, 1) 100%);",
    backgroundGradientWorkflowsLight: "linear-gradient(180deg, rgba(255, 153, 85, 0.2) 0%, rgba(253, 98, 176, 0.2) 50%, rgba(175, 128, 244, 0.2) 100%);",
    backgroundGradientPromote: "linear-gradient(90deg, #48257D 0.33%, #452871 25.18%, #43296B 37.61%, #422A68 43.82%, #422B66 50.04%, #402C60 62.46%, #3E2D5A 74.89%, #3D2F54 87.32%, #3B304E 99.75%)",
    borderNeutralDefault: "#414045",
    borderNeutralDark: "#504f54",
    borderNeutralDisabled: "#36353b",
    borderNeutralTransparent: "#ffffff4d",
    borderSystemInfo: "#5a9dfc",
    borderSystemSuccess: "#23bd7d",
    borderSystemCritical: "#ff7073",
    borderSystemWarning: "#ed913b",
    borderMainPrimary: "#af80f4",
    borderMainActive: "#724ea7",
    textSystemInfo: "#7bb1fd",
    textSystemSuccess: "#41c890",
    textSystemWarning: "#f1a762",
    textSystemCritical: "#ff8d8f",
    textSystemPrimary: "#af80f4",
    textSystemPrimaryDark: "#bf99f6",
    textMainDefault: "#ffffff",
    textMainSubdued: "#c9cbcf",
    textMainDisabled: "#57585c",
    textMainActive: "#bf99f6",
    textOnpromoteDefault: "#ffffff",
    iconSystemInfo: "#5a9dfc",
    iconSystemSuccess: "#23bd7d",
    iconSystemWarning: "#ed913b",
    iconSystemCritical: "#ff7073",
    iconSystemPrimary: "#af80f4",
    iconSystemPrimaryDark: "#bf99f6",
    iconMainBrand: "#af80f4",
    iconMainDefault: "#ffffff",
    iconMainSubdued: "#c9cbcf",
    iconMainDisabled: "#57585c",
    iconMainActive: "#7bb1fd",
    miscSpecialPersonal: "#b26d00",
    miscSpecialViolet: "#6473c6",
    miscSpecialOrange: "#db6300",
    miscSpecialOrangeLight: "#1d1a18",
    miscSpecialYellow: "#d19804",
    miscSpecialIndigo: "#0a2463",
    miscSpecialDarkYellow: "#444336",
    miscSpecialDarkBlue: "#0c285e",
    miscSpecialLime: "#709f00",
    miscSpecialGrayDark: "#8997a9",
    miscSpecialGrayLight: "#35363b",
    miscSpecialTurquoise: "#00c1cc",
    miscSpecialTurquoiseLight: "#003a3d",
    miscSpecialPurple: "#af7fe6",
    miscSpecialPurpleLow: "#551d95",
    miscSpecialPurpleLight: "#432468",
    miscSpecialBrown: "#b38f7f",
    miscSpecialBrownLight: "#402e26",
    miscSocialFacebook: "#1877f2",
    miscSocialTwitter: "#3dacf0",
    miscSocialGooglePlus: "#d34836",
    miscSocialLinkedin: "#2187ec",
    miscSocialX: "#c4c4c4",
    miscPublicDefault: "#219475",
    miscPublicHover: "#239e7d",
    miscPublicSubdued: "#0d3a31",
    pricingScaleDefault: "#fd62b0",
    pricingScaleHover: "#fd7cbd",
    pricingScaleSubdued: "#220012",
    pricingLeadDefault: "#a77ef3",
    pricingLeadHover: "#b694f5",
    pricingLeadSubdued: "#23153d",
    pricingOptimizeDefault: "#a77ef3",
    pricingOptimizeHover: "#b694f5",
    pricingOptimizeSubdued: "#23153d",
    pricingGrowDefault: "#fd62b0",
    pricingGrowHover: "#fd7cbd",
    pricingGrowSubdued: "#220012",
    pricingStartDefault: "#ffffff",
    pricingStartHover: "#dfe0e2",
    white: "#ffffff",
    black: "#000000",
    colorBgDefault: "#222326",
    colorBgHover: "#2e2f33",
    colorBgActive: "#3d2c56",
    colorBgDisabled: "#414045",
    colorBgSelected: "#3d2c56",
    colorBgPrimaryDefault: "#af80f4",
    colorBgPrimaryHover: "#bf99f6",
    colorBgPrimaryPressed: "#cfb3f8",
    colorBgPrimarySelected: "#af80f4",
    colorBgPrimaryDisabled: "#724ea7",
    colorBgPrimarySubduedDefault: "#322447",
    colorBgPrimarySubduedHover: "#322447",
    colorBgPrimarySubduedSelected: "#322447",
    colorBgPrimarySubduedActive: "#322447",
    colorBgPrimaryStrongDefault: "#bf99f6",
    colorBgPrimaryLowDefault: "#3d2c56",
    colorBgPrimaryLowHover: "#3d2c56",
    colorBgPrimaryLowPressed: "#543680",
    colorBgNeutralDefault: "#1b1c1e",
    colorBgNeutralHover: "#36353b",
    colorBgNeutralPressed: "#414045",
    colorBgNeutralDisabled: "#504f54",
    colorBgNeutralSelected: "#2e2f33",
    colorBgNeutralLowDefault: "#2b2b2e",
    colorBgNeutralLowHover: "#38393d",
    colorBgNeutralLowDisabled: "#1b1c1e",
    colorBgNeutralStrongDefault: "#414045",
    colorBgNeutralStrongHover: "#504f54",
    colorBgSuccessDefault: "#23bd7d",
    colorBgSuccessHover: "#41c890",
    colorBgSuccessPressed: "#5fd2a3",
    colorBgSuccessDisabled: "#16784f",
    colorBgSuccessLowDefault: "#0b412b",
    colorBgSuccessLowHover: "#0b412b",
    colorBgSuccessLowPressed: "#0b412b",
    colorBgSuccessSubduedDefault: "#0b412b",
    colorBgSuccessSubduedHover: "#0f5235",
    colorBgSuccessSubduedPressed: "#16784f",
    colorBgCriticalDefault: "#ff7073",
    colorBgCriticalHover: "#ff8d8f",
    colorBgCriticalPressed: "#ffa9ab",
    colorBgCriticalDisabled: "#a74345",
    colorBgCriticalLowDefault: "#4f1618",
    colorBgCriticalLowHover: "#4f1618",
    colorBgCriticalLowPressed: "#4f1618",
    colorBgCriticalStrongDefault: "#ff8d8f",
    colorBgCriticalStrongActive: "#ffa9ab",
    colorBgCriticalSubduedDefault: "#230001",
    colorBgCriticalSubduedHover: "#7b2d2f",
    colorBgCriticalSubduedPressed: "#a74345",
    colorBgWarningDefault: "#ed913b",
    colorBgWarningHover: "#f1a762",
    colorBgWarningPressed: "#f4bd89",
    colorBgWarningDisabled: "#995d25",
    colorBgWarningLowDefault: "#512f10",
    colorBgWarningLowHover: "#512f10",
    colorBgWarningLowPressed: "#512f10",
    colorBgWarningSubduedDefault: "#512f10",
    colorBgWarningSubduedHover: "#603915",
    colorBgWarningSubduedPressed: "#995d25",
    colorBgScaleDefault: "#fd62b0",
    colorBgScaleHover: "#fd7cbd",
    colorBgScaleSubduedDefault: "#220012",
    colorBgLeadDefault: "#a77ef3",
    colorBgLeadHover: "#b694f5",
    colorBgLeadSubduedDefault: "#23153d",
    colorBgPrivateDefault: "#2d2c23",
    colorBgPrivateHover: "#343228",
    colorBgPrivateStrongDefault: "#343228",
    colorBgPrivateLowDefault: "#25241d",
    colorBgGradientSubdued: "linear-gradient(180deg, #222326 0%, #1d1d20 100%)",
    colorBgSecondaryDefault: "#c9cbcf",
    colorBgSecondaryDisabled: "#38393d",
    colorBgSecondaryStrongDefault: "#ffffff",
    colorBgSecondaryStrongHover: "#dfe0e2",
    colorBgSecondaryStrongPressed: "#d1d3d6",
    colorBgSecondaryStrongActive: "#f7f8f9",
    colorBgSecondarySubduedDefault: "#313235",
    colorBgSecondaryLowDefault: "#95989d",
    colorBgSecondaryLowDisabled: "#57585c",
    colorBgInfoDefault: "#5a9dfc",
    colorBgInfoHover: "#7bb1fd",
    colorBgInfoPressed: "#9cc4fd",
    colorBgInfoDisabled: "#3663a1",
    colorBgInfoStrongDefault: "#7bb1fd",
    colorBgInfoLowDefault: "#152e51",
    colorBgInfoLowHover: "#152e51",
    colorBgInfoLowPressed: "#152e51",
    colorBgOverdueDefault: "#db6300",
    colorBgOverdueLowDefault: "#1d1a18",
    colorBgNoconsentDefault: "#1d1a18",
    colorBgNodataDefault: "#1d1a18",
    colorBgTeamDefault: "#6473c6",
    colorBgPersonalDefault: "#b26d00",
    colorBgOverlayDefault: "#000000cc",
    colorBgOnoverlayHover: "#ffffff1a",
    colorBgOnoverlayPressed: "#ffffff33",
    colorBgGhostHover: "#ffffff1a",
    colorBgGhostPressed: "#ffffff33",
    colorBgTintDefault: "#ffffff4d",
    colorBgLoadingDefault: "#ffffff26",
    colorBgOfferDefault: "#af7fe6",
    colorBgOfferHover: "#bc94ea",
    colorBgOfferPressed: "#caaaee",
    colorBgOfferLowDefault: "#432468",
    colorBgOfferLowHover: "#432468",
    colorBgRequisitionSubduedDefault: "#432468",
    colorBgScreeningDefault: "#7bb1fd",
    colorBgScreeningHover: "#9cc4fd",
    colorBgScreeningPressed: "#bdd8fe",
    colorBgScreeningLowDefault: "#152e51",
    colorBgInterviewDefault: "#5a9dfc",
    colorBgInterviewHover: "#7bb1fd",
    colorBgInterviewPressed: "#9cc4fd",
    colorBgInterviewLowDefault: "#152e51",
    colorBgEvaluationDefault: "#00c1cc",
    colorBgEvaluationHover: "#00d0db",
    colorBgEvaluationPressed: "#00deeb",
    colorBgEvaluationLowDefault: "#003a3d",
    colorBgEvaluationLowHover: "#003a3d",
    colorBgJobSubduedDefault: "#003a3d",
    colorBgHiredDefault: "#23bd7d",
    colorBgHiredHover: "#41c890",
    colorBgHiredPressed: "#5fd2a3",
    colorBgHiredLowDefault: "#0b412b",
    colorBgTranslateDefault: "#ed913b",
    colorBgChartDefault: "#7427f81a",
    colorBgVersatileSecondaryStrongDefault: "#45454a",
    colorBgVersatileSecondaryStrongHover: "#313135",
    colorBgVersatileSecondaryStrongPressed: "#484c5b",
    colorBgVersatileSecondaryStrongActive: "#3b3b40",
    colorBgVersatileSecondaryDefault: "#5a5f72",
    colorBgVersatileSecondaryHover: "#484c5b",
    colorBgVersatileSecondaryMediumDefault: "#313135",
    colorBgVersatileSecondaryMediumHover: "#404045",
    colorBgVersatileSecondaryMediumActive: "#62626a",
    colorBgSkeletonDefault: "#303236",
    colorBgOncomponentDefault: "#3e3d42",
    colorBgOncomponentHover: "#3e3d42",
    colorBgOncomponentActive: "#3e3d42",
    colorBgOptimizeDefault: "#a77ef3",
    colorBgOptimizeHover: "#b694f5",
    colorBgOptimizeSubduedDefault: "#23153d",
    colorBgGrowDefault: "#fd62b0",
    colorBgGrowHover: "#fd62b0",
    colorBgGrowSubduedDefault: "#220012",
    colorBgStartDefault: "#ffffff",
    colorBgStartHover: "#dfe0e2",
    colorBgOnboardingDefault: "#543680",
    colorBgOnboardingHover: "#543680",
    colorBgOnboardingLowDefault: "#35373b",
    colorBgOnboardingLowActive: "#4f4f4f",
    colorBgOnboardingSubduedDefault: "#452334",
    colorBgOnboardingStrongDefault: "#a53b71",
    colorBgOnboardingStrongHover: "#a53b71",
    colorBgOnboardingActive: "#fd62b0",
    colorBgTellentDefault: "#e83393",
    colorBgTellentHover: "#ec53a4",
    colorBgTellentPressed: "#ef73b5",
    colorBgTellentActive: "#420027",
    colorBgAppliedDefault: "#8997a9",
    colorBgAppliedHover: "#98a4b4",
    colorBgAppliedPressed: "#a7b1be",
    colorBgAppliedLowDefault: "#35363b",
    colorBgNotypeDefault: "#b38f7f",
    colorBgNotypeHover: "#bd9d8f",
    colorBgNotypePressed: "#c6ab9f",
    colorBgNotypeLowDefault: "#402e26",
    colorBgKiwiDefault: "#00853e",
    colorBgKiwiHover: "#6fb688",
    colorBgKiwiPressed: "#92c8a5",
    colorBgKiwiSubduedHover: "#1a402c",
    colorBgJaveloDefault: "#d14905",
    colorBgJaveloHover: "#5f240b",
    colorBgRecruiteeDefault: "#078fe4",
    colorBgPublicSubduedDefault: "#0d3a31",
    colorBgArticleTurquoiseSubduedDefault: "#003a3d",
    colorBgArticlePurpleSubduedDefault: "#3c156b",
    colorBgAccentDefault: "#fd62b0",
    colorBgAccentHover: "#fd62b0",
    colorBgAccentPressed: "#fd81c0",
    colorBgAccentActive: "#fd62b0",
    colorBgAccentSubduedDefault: "#4e1432",
    colorBgAccentSubduedHover: "#4e1432",
    colorBgAccentSubduedPressed: "#4e1432",
    colorBgAccentStrongDefault: "#fd81c0",
    colorBgImpactDefault: "#a060ff",
    colorBgImpactLowPressed: "#7552a7",
    colorBgImpactSubduedDefault: "#4c376c",
    colorBgImpactSubduedHover: "#683aab",
    colorBgAttendanceSubduedDefault: "#ffedf5",
    colorBgEmployeesSubduedDefault: "#fff3e5",
    colorBgTimeoffSubduedDefault: "#e9f3ff",
    colorBgCompanySubduedDefault: "#ebfafb",
    colorBgPayrollSubduedDefault: "#f7e6f8",
    colorBgExpensesSubduedDefault: "#e6e6f4",
    colorBgReportsSubduedDefault: "#e8f9ee",
    colorBgQuoteDefault: "#bb89e0",
    colorBgWorkflowsDefault: "linear-gradient(180deg, rgba(255, 153, 85, 0.2) 0%, rgba(253, 98, 176, 0.2) 50%, rgba(175, 128, 244, 0.2) 100%);",
    colorBgWorkflowsHover: "linear-gradient(180deg, rgba(255, 153, 85, 0.2) 0%, rgba(253, 98, 176, 0.2) 50%, rgba(175, 128, 244, 0.2) 100%);",
    colorBgWorkflowsLowDefault: "#5b1c52",
    colorBgAiSubduedDefault: "#332d41",
    colorBgAiLowDefault: "#3b3549",
    colorBgAiStrongDefault: "#901c9d",
    colorBgPromoteDefault: "#5018a5",
    colorBgPromoteDefaultCopy: "#5719b3",
    colorBgSyncDefault: "#3d1e39",
    colorBgSurveyDefault: "#3d1e39",
    colorBgAiTriggerDefault: "#712d78",
    colorTextDefault: "#c9cbcf",
    colorTextHover: "#ffffff",
    colorTextPressed: "#ffffff",
    colorTextDisabled: "#57585c",
    colorTextActive: "#bf99f6",
    colorTextStrongDefault: "#ffffff",
    colorTextStrongHover: "#ffffff",
    colorTextStrongSelected: "#ffffff",
    colorTextLowDefault: "#95989d",
    colorTextOnprimaryDefault: "#000000",
    colorTextOnprimaryHover: "#000000",
    colorTextOnprimaryPressed: "#000000",
    colorTextOnprimaryDisabled: "#000000",
    colorTextOnprimarySelected: "#000000",
    colorTextOnneutralDisabled: "#6d6b70",
    colorTextOnsuccessDefault: "#000000",
    colorTextOnsuccessHover: "#000000",
    colorTextOnsuccessPressed: "#000000",
    colorTextOncriticalDefault: "#000000",
    colorTextOncriticalHover: "#000000",
    colorTextOncriticalPressed: "#000000",
    colorTextOnwarningDefault: "#000000",
    colorTextOnwarningHover: "#000000",
    colorTextOnwarningPressed: "#000000",
    colorTextSuccessDefault: "#23bd7d",
    colorTextSuccessHover: "#23bd7d",
    colorTextSuccessPressed: "#41c890",
    colorTextSuccessStrongDefault: "#41c890",
    colorTextSuccessStrongHover: "#5fd2a3",
    colorTextSuccessStrongPressed: "#7eddb5",
    colorTextCriticalDefault: "#ff7073",
    colorTextCriticalHover: "#ff7073",
    colorTextCriticalPressed: "#ff8d8f",
    colorTextCriticalStrongDefault: "#ff8d8f",
    colorTextCriticalStrongHover: "#ffa9ab",
    colorTextCriticalStrongPressed: "#ffc6c7",
    colorTextInfoDefault: "#5a9dfc",
    colorTextInfoHover: "#5a9dfc",
    colorTextInfoPressed: "#7bb1fd",
    colorTextInfoStrongDefault: "#7bb1fd",
    colorTextWarningDefault: "#ed913b",
    colorTextWarningHover: "#ed913b",
    colorTextWarningPressed: "#f1a762",
    colorTextWarningStrongDefault: "#f1a762",
    colorTextWarningStrongHover: "#f4bd89",
    colorTextWarningStrongPressed: "#f8d3b1",
    colorTextOnscaleDefault: "#000000",
    colorTextOnscaleHover: "#000000",
    colorTextOnleadDefault: "#000000",
    colorTextOnleadHover: "#000000",
    colorTextScaleDefault: "#fd62b0",
    colorTextScaleHover: "#fd7cbd",
    colorTextOngradientDefault: "#000000",
    colorTextLeadDefault: "#a77ef3",
    colorTextOnsecondaryDefault: "#ffffff",
    colorTextOnsecondaryStrongDefault: "#ffffff",
    colorTextOnsecondaryStrongHover: "#ffffff",
    colorTextOnsecondaryStrongPressed: "#ffffff",
    colorTextOninfoStrongDefault: "#000000",
    colorTextOninfoDefault: "#000000",
    colorTextOninfoHover: "#000000",
    colorTextOninfoPressed: "#000000",
    colorTextOverdueDefault: "#db6300",
    colorTextOnoverdueDefault: "#ffffff",
    colorTextNoconsentDefault: "#db6300",
    colorTextNodataDefault: "#db6300",
    colorTextOnoverlayDefault: "#ffffff",
    colorTextOnoverlayHover: "#ffffff",
    colorTextOnoverlayPressed: "#ffffff",
    colorTextOnoverlayDisabled: "#95989d",
    colorTextOnoverlayLowDefault: "#36353b",
    colorTextOnghostDefault: "#ffffff",
    colorTextOnghostHover: "#ffffff",
    colorTextOnghostPressed: "#ffffff",
    colorTextOnghostDisabled: "#95989d",
    colorTextPrimaryDefault: "#af80f4",
    colorTextPrimaryActive: "#af80f4",
    colorTextPrimaryHover: "#bf99f6",
    colorTextPrimaryPressed: "#bf99f6",
    colorTextPrimaryStrongDefault: "#bf99f6",
    colorTextPrimaryStrongActive: "#bf99f6",
    colorTextOnteamDefault: "#ffffff",
    colorTextOncomponentDefault: "#ffffff",
    colorTextOnoptimizeDefault: "#000000",
    colorTextOnoptimizeHover: "#000000",
    colorTextOptimizeDefault: "#a77ef3",
    colorTextOptimizeHover: "#b694f5",
    colorTextOngrowDefault: "#000000",
    colorTextOngrowHover: "#000000",
    colorTextGrowDefault: "#fd62b0",
    colorTextGrowHover: "#fd7cbd",
    colorTextOnstartDefault: "#0e0e0f",
    colorTextOnstartHover: "#0e0e0f",
    colorTextOnboardingLowDefault: "#cfb3f8",
    colorTextOnboardingDefault: "#ffffff",
    colorTextOnonboardingDefault: "#ffffff",
    colorTextOnonboardingHover: "#ffffff",
    colorTextOntellentDefault: "#ffffff",
    colorTextOntellentHover: "#ffffff",
    colorTextOntellentPressed: "#ffffff",
    colorTextOnappliedDefault: "#000000",
    colorTextOnappliedHover: "#000000",
    colorTextOnappliedPressed: "#000000",
    colorTextOnscreeningDefault: "#000000",
    colorTextOnscreeningHover: "#000000",
    colorTextOnscreeningPressed: "#000000",
    colorTextOninterviewDefault: "#000000",
    colorTextOninterviewHover: "#000000",
    colorTextOninterviewPressed: "#000000",
    colorTextOnevaluationDefault: "#000000",
    colorTextOnevaluationHover: "#000000",
    colorTextOnevaluationPressed: "#000000",
    colorTextOnofferDefault: "#000000",
    colorTextOnofferHover: "#000000",
    colorTextOnofferPressed: "#000000",
    colorTextOnhiredDefault: "#000000",
    colorTextOnhiredHover: "#000000",
    colorTextOnhiredPressed: "#000000",
    colorTextOnnotypeDefault: "#000000",
    colorTextOnnotypeHover: "#000000",
    colorTextOnnotypePressed: "#000000",
    colorTextOnkiwiDefault: "#ffffff",
    colorTextOnkiwiHover: "#ffffff",
    colorTextOnkiwiPressed: "#ffffff",
    colorTextOnjaveloDefault: "#ffffff",
    colorTextOnrecruiteeDefault: "#ffffff",
    colorTextRecruiteeDefault: "#078fe4",
    colorTextRecruiteeStrongDefault: "#429ed7",
    colorTextKiwiDefault: "#00853e",
    colorTextKiwiStrongDefault: "#6fb688",
    colorTextAccentDefault: "#fd62b0",
    colorTextAccentHover: "#fd81c0",
    colorTextAccentPressed: "#fd81c0",
    colorTextOnaccentDefault: "#000000",
    colorTextOnaccentHover: "#000000",
    colorTextOnaccentPressed: "#000000",
    colorTextImpactDefault: "#a060ff",
    colorTextImpactHover: "#ccabff",
    colorTextImpactPressed: "#ccabff",
    colorTextAiDefault: "linear-gradient(-90deg, #DABFF5 0%, #EDC2E1 100%)",
    colorTextLinkDefault: "#af80f4",
    colorTextLinkHover: "#bf99f6",
    colorTextOfferDefault: "#af7fe6",
    colorIconDefault: "#c9cbcf",
    colorIconHover: "#ffffff",
    colorIconPressed: "#ffffff",
    colorIconDisabled: "#57585c",
    colorIconActive: "#7bb1fd",
    colorIconStrongDefault: "#ffffff",
    colorIconOnprimaryDefault: "#000000",
    colorIconOnprimaryHover: "#000000",
    colorIconOnprimaryPressed: "#000000",
    colorIconOnprimaryDisabled: "#000000",
    colorIconOnneutralDisabled: "#6d6b70",
    colorIconOnsuccessDefault: "#000000",
    colorIconOnsuccessHover: "#000000",
    colorIconOnsuccessPressed: "#000000",
    colorIconOnsuccessDisabled: "#000000",
    colorIconOncriticalDefault: "#000000",
    colorIconOncriticalHover: "#000000",
    colorIconOncriticalPressed: "#000000",
    colorIconOnwarningDefault: "#000000",
    colorIconOnwarningHover: "#000000",
    colorIconOnwarningPressed: "#000000",
    colorIconSuccessDefault: "#23bd7d",
    colorIconSuccessHover: "#23bd7d",
    colorIconSuccessPressed: "#41c890",
    colorIconSuccessActive: "#5fd2a3",
    colorIconSuccessStrongDefault: "#41c890",
    colorIconSuccessStrongHover: "#5fd2a3",
    colorIconSuccessStrongPressed: "#7eddb5",
    colorIconCriticalDefault: "#ff7073",
    colorIconCriticalHover: "#ff7073",
    colorIconCriticalPressed: "#ff8d8f",
    colorIconCriticalStrongDefault: "#ff8d8f",
    colorIconCriticalStrongHover: "#ffa9ab",
    colorIconCriticalStrongPressed: "#ffc6c7",
    colorIconInfoDefault: "#5a9dfc",
    colorIconInfoHover: "#5a9dfc",
    colorIconInfoPressed: "#7bb1fd",
    colorIconInfoStrongDefault: "#7bb1fd",
    colorIconWarningDefault: "#ed913b",
    colorIconWarningHover: "#ed913b",
    colorIconWarningPressed: "#f1a762",
    colorIconWarningStrongDefault: "#f1a762",
    colorIconWarningStrongHover: "#f4bd89",
    colorIconWarningStrongPressed: "#f8d3b1",
    colorIconScaleDefault: "#fd62b0",
    colorIconScaleHover: "#fd7cbd",
    colorIconOngradientDefault: "#000000",
    colorIconOnscaleDefault: "#000000",
    colorIconOnscaleHover: "#000000",
    colorIconLeadDefault: "#a77ef3",
    colorIconOnleadDefault: "#000000",
    colorIconOnleadHover: "#000000",
    colorIconOnsecondaryDefault: "#ffffff",
    colorIconOnsecondaryStrongDefault: "#ffffff",
    colorIconOnsecondaryStrongHover: "#ffffff",
    colorIconOninfoStrongDefault: "#000000",
    colorIconOninfoDefault: "#000000",
    colorIconOninfoHover: "#000000",
    colorIconOninfoPressed: "#000000",
    colorIconOverdueDefault: "#db6300",
    colorIconOnoverdueDefault: "#ffffff",
    colorIconNoconsentDefault: "#db6300",
    colorIconNodataDefault: "#db6300",
    colorIconOnoverlayDefault: "#ffffff",
    colorIconOnoverlayHover: "#ffffff",
    colorIconOnoverlayPressed: "#ffffff",
    colorIconOnoverlayDisabled: "#95989d",
    colorIconOnghostDefault: "#ffffff",
    colorIconOnghostHover: "#ffffff",
    colorIconOnghostPressed: "#ffffff",
    colorIconOnghostDisabled: "#95989d",
    colorIconPrimaryDefault: "#af80f4",
    colorIconPrimaryHover: "#bf99f6",
    colorIconPrimaryPressed: "#af80f4",
    colorIconPrimaryStrongDefault: "#bf99f6",
    colorIconPrimaryStrongPressed: "#bf99f6",
    colorIconLowDefault: "#95989d",
    colorIconLowDisabled: "#504f54",
    colorIconSubduedDefault: "#313235",
    colorIconOncomponentDefault: "#ffffff",
    colorIconAiDefault: "linear-gradient(-90deg, #DABFF5 0%, #EDC2E1 100%)",
    colorIconAiStrongDefault: "#dabff5",
    colorIconTranslateDefault: "#ed913b",
    colorIconOptimizeDefault: "#a77ef3",
    colorIconOptimizeHover: "#b694f5",
    colorIconOnoptimizeDefault: "#000000",
    colorIconOnoptimizeHover: "#000000",
    colorIconGrowDefault: "#fd62b0",
    colorIconGrowHover: "#fd7cbd",
    colorIconOngrowDefault: "#000000",
    colorIconOngrowHover: "#000000",
    colorIconOnboardingDefault: "#fd62b0",
    colorIconOnboardingLowDefault: "#cfb3f8",
    colorIconOnonboardingDefault: "#ffffff",
    colorIconOnonboardingHover: "#ffffff",
    colorIconOnhiredDefault: "#000000",
    colorIconOnhiredHover: "#000000",
    colorIconOnhiredPressed: "#000000",
    colorIconOnkiwiDefault: "#ffffff",
    colorIconOnkiwiHover: "#ffffff",
    colorIconOnkiwiPressed: "#ffffff",
    colorIconOnjaveloDefault: "#ffffff",
    colorIconOnappliedDefault: "#000000",
    colorIconOnappliedHover: "#000000",
    colorIconOnappliedPressed: "#000000",
    colorIconOnscreeningDefault: "#000000",
    colorIconOnscreeningHover: "#000000",
    colorIconOnscreeningPressed: "#000000",
    colorIconOninterviewDefault: "#000000",
    colorIconOninterviewHover: "#000000",
    colorIconOninterviewPressed: "#000000",
    colorIconOnnotypeDefault: "#000000",
    colorIconOnnotypeHover: "#000000",
    colorIconOnnotypePressed: "#000000",
    colorIconOnevaluationDefault: "#000000",
    colorIconOnevaluationHover: "#000000",
    colorIconOnevaluationPressed: "#000000",
    colorIconOnofferDefault: "#000000",
    colorIconOnofferHover: "#000000",
    colorIconOnofferPressed: "#000000",
    colorIconOntellentDefault: "#ffffff",
    colorIconOntellentHover: "#ffffff",
    colorIconOntellentPressed: "#ffffff",
    colorIconTellentDefault: "#e83393",
    colorIconTellentActive: "#e83393",
    colorIconOfferDefault: "#af7fe6",
    colorIconEvaluationDefault: "#00c1cc",
    colorIconPublicDefault: "#219475",
    colorIconRecruiteeDefault: "#078fe4",
    colorIconKiwiDefault: "#00853e",
    colorIconRequisitionDefault: "#af7fe6",
    colorIconJobDefault: "#00c1cc",
    colorIconArticleTurquoiseDefault: "#009199",
    colorIconArticlePurpleDefault: "#863eda",
    colorIconAccentDefault: "#fd62b0",
    colorIconAccentHover: "#fd62b0",
    colorIconAccentPressed: "#fd81c0",
    colorIconOnaccentDefault: "#ffffff",
    colorIconOnaccentHover: "#ffffff",
    colorIconOnaccentPressed: "#ffffff",
    colorIconImpactDefault: "#a060ff",
    colorIconImpactHover: "#ccabff",
    colorIconImpactPressed: "#ccabff",
    colorIconAttendanceDefault: "#f65978",
    colorIconEmployeesDefault: "#ffaa45",
    colorIconTimeoffDefault: "#61a5ff",
    colorIconCompanyDefault: "#34d0d7",
    colorIconPayrollDefault: "#c746cb",
    colorIconExpensesDefault: "#0e0bc7",
    colorIconReportsDefault: "#56d586",
    colorIconLinkDefault: "#af80f4",
    colorIconLinkHover: "#bf99f6",
    colorIconWorkflowsDefault: "linear-gradient(180deg, rgba(255, 153, 85, 1) 0%, rgba(253, 98, 176, 1) 50%, rgba(175, 128, 244, 1) 100%);",
    colorBorderAiDefault: "#423450",
    colorBorderDefault: "#414045",
    colorBorderHover: "#414045",
    colorBorderPressed: "#414045",
    colorBorderDisabled: "#36353b",
    colorBorderSelected: "#414045",
    colorBorderActive: "#724ea7",
    colorBorderSuccessDefault: "#23bd7d",
    colorBorderSuccessHover: "#23bd7d",
    colorBorderSuccessPressed: "#41c890",
    colorBorderSuccessSubduedDefault: "#0f5235",
    colorBorderSuccessLowDefault: "#1d9b66",
    colorBorderCriticalDefault: "#ff7073",
    colorBorderCriticalHover: "#ff7073",
    colorBorderCriticalPressed: "#ff8d8f",
    colorBorderCriticalLowDefault: "#a74345",
    colorBorderCriticalSubduedDefault: "#7b2d2f",
    colorBorderInfoDefault: "#5a9dfc",
    colorBorderInfoHover: "#5a9dfc",
    colorBorderInfoPressed: "#7bb1fd",
    colorBorderInfoSubduedDefault: "#1d3a63",
    colorBorderWarningDefault: "#ed913b",
    colorBorderWarningHover: "#ed913b",
    colorBorderWarningPressed: "#f1a762",
    colorBorderWarningDisabled: "#995d25",
    colorBorderWarningSubduedDefault: "#603915",
    colorBorderNeutralHover: "#504f54",
    colorBorderNeutralDisabled: "#1b1c1e",
    colorBorderOncomponentDefault: "#222326",
    colorBorderSecondaryDefault: "#c9cbcf",
    colorBorderSecondaryHover: "#ffffff",
    colorBorderSecondaryDisabled: "#57585c",
    colorBorderSecondaryLowDefault: "#95989d",
    colorBorderSecondaryLowDisabled: "#494b50",
    colorBorderSecondaryStrongDefault: "#dfe0e2",
    colorBorderPrimaryDefault: "#af80f4",
    colorBorderPrimaryHover: "#bf99f6",
    colorBorderPrimaryStrongDefault: "#bf99f6",
    colorBorderPrimarySubduedDefault: "#543680",
    colorBorderPrimaryLowDefault: "#9167cd",
    colorBorderTranslateDefault: "#ed913b",
    colorBorderOnghostDefault: "#ffffff",
    colorBorderOnghostHover: "#ffffff",
    colorBorderOnghostPressed: "#ffffff",
    colorBorderOnghostDisabled: "#95989d",
    colorBorderPrivateDefault: "#444336",
    colorBorderStrongDefault: "#504f54",
    colorBorderStrongDisabled: "#504f54",
    colorBorderLowDefault: "#36353b",
    colorBorderLowHover: "#313235",
    colorBorderTeamDefault: "#6473c6",
    colorBorderVersatileSecondaryDefault: "#57565d",
    colorBorderTintDefault: "#ffffff4d",
    colorBorderAccentDefault: "#fd62b0",
    colorBorderAccentHover: "#fd62b0",
    colorBorderAccentPressed: "#fd81c0",
    colorBorderAccentSubduedDefault: "#7a2751",
    colorBorderImpactDefault: "#7552a7",
    colorBorderImpactHover: "#7552a7",
    colorBorderImpactPressed: "#7552a7",
    colorBorderOnprimaryDefault: "#000000",
    colorBorderOnprimaryHover: "#000000",
    colorBorderOnprimaryPressed: "#000000",
    colorBorderOfferSubduedDefault: "#551d95",
    colorBorderOnboardingDefault: "#fd62b0",
    colorGradientPrimary: "linear-gradient(270deg, #078FE4 0%, #163EA2 100%)",
    colorGradientLaunch: "linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)",
    colorGradientScale: "linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)",
    colorGradientLead: "linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)",
    colorGradientPurple: "linear-gradient(-90deg, #C177D5 30%, #653EAC 70%)",
    colorGradientOrange: "linear-gradient(90deg, #C45A03 27.46%, #EEAF0C 100%)",
    colorGradientRed: "linear-gradient(90deg, #F9062B 27.46%, #FFDBD4 100%)",
    colorGradientLightBlue: "linear-gradient(45deg, #0789D9 0%, #62C2F9 100%)",
    colorGradientVideo: "linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)",
    colorGradientVideoOverlay: "linear-gradient(45deg, rgba(23, 66, 152, 0.7) 0%, rgba(113, 72, 189, 0.7) 52%, rgba(175, 126, 230, 0.7) 100%)",
    colorGradientFindTimeNeutral: "repeating-linear-gradient(135deg, #303236, #303236 6px, #484A51 6px, #484A51 12px)",
    colorGradientFindTimePrimary: "repeating-linear-gradient(135deg, #362252, #362252 6px, #4B336F 6px, #4B336F 12px)",
    colorGradientFindTimeViolet: "repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)",
    colorGradientTruncate: "#e8198a00",
    colorGradientShimmer: "linear-gradient(-60deg, #e8198a 30%, #e8198a5, #e8198a 70%) right/300% 100%",
    colorGradientRainbow: "linear-gradient(90deg, rgb(90, 55, 154) 0%, rgb(184, 99, 207) 7%, rgb(20, 121, 179) 14%, rgb(73, 184, 248) 21%, rgb(85, 199, 82) 27%, rgb(39, 150, 118) 33.33%, rgb(104, 205, 101) 36%, rgb(98, 194, 249) 42%, rgb(22, 136, 202) 47%, rgb(193, 119, 213) 53%, rgb(101, 62, 172) 60%, rgb(22, 136, 202) 66.66%, rgb(98, 194, 249) 100%)",
    colorGradientNeutralToTransparent: "linear-gradient(to bottom, rgba(29, 30, 32, 1) 0%, rgba(29, 30, 32, 0) 100%)",
    colorGradientTellent: "linear-gradient(90deg, #681D74 0%, #230AC0 100%)",
    colorGradientPink: "linear-gradient(90deg, #af80f4 0%, #fd62b0 100%)",
    colorGradientImpact: "linear-gradient(90deg, #48257D 0%, #3B2F4E 100%)",
    colorGradientAiDefault: "linear-gradient(-90deg, #633068 0%, #383262 100%)",
    colorGradientAiSubduedDefault: "linear-gradient(-90deg, #372C3E 0%, #332D41 100%)",
    colorGradientAiStrongDefault: "linear-gradient(-90deg, #EDC2E1 0%, #DABFF5 100%)",
    colorGradientAiLowDefault: "linear-gradient(90deg, #803A94 0%, #773A98 25%, #723B9B 50%, #6A3A9E 75%, #643BA1 100%)",
    colorGradientGrow: "linear-gradient(90deg, #BDA4E2 0%, #36116E 100%)",
    colorGradientWorkflows: "linear-gradient(180deg, rgba(255, 153, 85, 1) 0%, rgba(253, 98, 176, 1) 50%, rgba(175, 128, 244, 1) 100%);",
    colorGradientWorkflowsLight: "linear-gradient(180deg, rgba(255, 153, 85, 0.2) 0%, rgba(253, 98, 176, 0.2) 50%, rgba(175, 128, 244, 0.2) 100%);",
    colorGradientPromote: "linear-gradient(90deg, #48257D 0.33%, #452871 25.18%, #43296B 37.61%, #422A68 43.82%, #422B66 50.04%, #402C60 62.46%, #3E2D5A 74.89%, #3D2F54 87.32%, #3B304E 99.75%)",
    colorTooltipFeature: "#0c285e",
    colorTooltipFeatureLight: "#0988de",
    colorAvatarSteelLighter: "#ad94e0",
    colorAvatarSteelLight: "#313235",
    colorAvatarSteelDark: "#61636b",
    colorAvatarGrayLight: "#414045",
    colorAvatarGrayDark: "#838288",
    colorAvatarGreen: "#4cc99f",
    colorAvatarBlueLight: "#5a9dfc",
    colorAvatarBlueDark: "#bd6bb3",
    colorAvatarBlueDarker: "#dfccfb",
    colorAvatarPink: "#9a4cb6",
    colorAvatarPurple: "#b694f5",
    colorAvatarYellow: "#ed913b",
    colorAvatarOrange: "#db6300",
    colorAvatarSkeleton: "#2e2f33",
    colorChartPrimaryDefault: "#8659ca",
    colorChartBlueDefault: "#f47174",
    colorChartTurquoiseDefault: "#008ee5",
    colorChartPurpleDefault: "#e566a5",
    colorChartPurpleSubduedDefault: "#03ad9c",
    colorChartGrayDefault: "#a6a2af",
    colorChartGreenDefault: "#45c2d1",
    colorChartGreenSubduedDefault: "#cd75bc",
    colorChartBlueStrongDefault: "#ffd76f",
    colorChartYellowDefault: "#feb07b",
    colorChartYellowSubduedDefault: "#6871ee",
    colorChartOrangeDefault: "#b2a1f7",
    colorSeparatorTransparent: "#00000033",
    colorLogoTypographyDefault: "#b57fef",
    colorLogoTypographyStrongDefault: "#ece0f5",
    colorLogoSignSubduedDefault: "#3d2c56",
    colorLogoSignPrimaryDefault: "#b57fef",
    colorLogoSignAccentDefault: "#ee5fb2",
    colorCandidatesBgPrimaryDefault: "#8659ca",
    colorCandidatesBgGreenStrongDefault: "#1a8e68",
    colorCandidatesBgOrangeDefault: "#c45a03",
    colorCandidatesBgYellowDefault: "#f2b10d",
    colorCandidatesBgGreenSubduedDefault: "#2caa86",
    colorCandidatesBgBlueDefault: "#0c6090",
    colorCandidatesBgVioletDefault: "#512fa2",
    colorCandidatesBgGreenDefault: "#46af0e",
    colorCandidatesBgBlueStrongDefault: "#083f5e",
    colorCandidatesBgPurpleDefault: "#8c44a7",
    colorCandidatesBorderPrimaryDefault: "#8659ca",
    colorCandidatesBorderGreenStrongDefault: "#1a8e68",
    colorCandidatesBorderOrangeDefault: "#c45a03",
    colorCandidatesBorderYellowDefault: "#f2b10d",
    colorCandidatesBorderGreenSubduedDefault: "#2caa86",
    colorCandidatesBorderBlueDefault: "#0c6090",
    colorCandidatesBorderVioletDefault: "#512fa2",
    colorCandidatesBorderGreenDefault: "#46af0e",
    colorCandidatesBorderBlueStrongDefault: "#083f5e",
    colorCandidatesBorderPurpleDefault: "#8c44a7",
    colorScrollbarThumbDefault: "#5a5a5a",
    colorScrollbarThumbHover: "#737373",
    colorScrollbarTrackDefault: "#2e2f30",
    colorMarketplaceLogo: "#ffffff",
    colorMarketplaceRibbon: "#16784f",
    colorVersatileDefault: "#ffffff",
    colorFacebookDefault: "#1877f2",
    colorLinkedinDefault: "#2187ec",
    colorGoogleplusDefault: "#d34836",
    colorXDefault: "#c4c4c4",
    colorNavBgNeutralDefault: "#1b1c1e",
    colorNavBgNeutralLowHover: "#36353b",
    colorNavBgActive: "#3d2c56",
    colorNavBgPrimarySubduedDefault: "#3f2961",
    colorNavTextDefault: "#c9cbcf",
    colorNavTextStrongDefault: "#ffffff",
    colorNavTextPrimaryActive: "#af80f4",
    colorNavTextLowDefault: "#95989d",
    colorNavIconDefault: "#c9cbcf",
    colorNavIconStrongDefault: "#ffffff",
    colorNavIconPrimaryDefault: "#af80f4",
    colorNavIconDisabled: "#57585c",
    colorNavBorderDefault: "#414045",
    shadow100: "0 2px 5px 0 rgba(0,0,0,0.16), 0 1px 1px 0 rgba(0,0,0,0.18)",
    shadow200: "0 2px 5px 0 rgba(0,0,0,0.10), 0 1px 2px 0 rgba(0,0,0,0.10)",
    shadow300: "0 5px 5px 0 rgba(0,0,0,0.10), 0 5px 9px 0 rgba(0,0,0,0.10), 0 3px 3px 0 rgba(0,0,0,0.10), 0 0 1px 0 rgba(0,0,0,0.10)",
    shadow400: "0 26px 10px 0 rgba(0,0,0,0.08), 0 15px 9px 0 rgba(0,0,0,0.10), 0 7px 7px 0 rgba(0,0,0,0.10), 0 2px 12px 0 rgba(0,0,0,0.10)",
    shadow500: "0 4px 28px 0 rgba(0,0,0,0.26)",
    shadow600: "0 0 32px 0 rgba(0,0,0,0.50)",
    shadowBase100: "0 2px 5px 0 rgba(0,0,0,0.16), 0 1px 1px 0 rgba(0,0,0,0.18)",
    shadowNavSwitcherHover: "0 2px 5px 0 rgba(0,0,0,0.16), 0 1px 1px 0 rgba(0,0,0,0.18)",
    shadowNavSwitcherActive: "0 2px 5px 0 rgba(0,0,0,0.10), 0 1px 2px 0 rgba(0,0,0,0.10)",
    shadowNavHovered: "0 3px 30px 0 rgba(0,0,0,0.50)",
    shadowInteraction200: "0 2px 5px 0 rgba(0,0,0,0.10), 0 1px 2px 0 rgba(0,0,0,0.10)",
    shadowWysiwigToolbarTop: "0 -2px 5px 0 rgba(0,0,0,0.10), 0 -1px 2px 0 rgba(0,0,0,0.10)",
    shadowToast300: "0 5px 5px 0 rgba(0,0,0,0.10), 0 5px 9px 0 rgba(0,0,0,0.10), 0 3px 3px 0 rgba(0,0,0,0.10), 0 0 1px 0 rgba(0,0,0,0.10)",
    shadowDropdown400: "0 26px 10px 0 rgba(0,0,0,0.08), 0 15px 9px 0 rgba(0,0,0,0.10), 0 7px 7px 0 rgba(0,0,0,0.10), 0 2px 12px 0 rgba(0,0,0,0.10)",
    shadowFloat500: "0 4px 28px 0 rgba(0,0,0,0.26)",
    shadowDialog600: "0 0 32px 0 rgba(0,0,0,0.50)",
    shadowBorderFormFocusDefault: "0 0 0 3px rgba(175,128,244,0.3)",
    shadowBorderFormFocusTranslate: "0 0 0 1px rgba(181,117,0,1)",
    shadowBorderFormHoverCritical: "0 0 0 1px #DA4538",
    shadowBorderCardActive: "0 0 0 4px rgba(175,128,244,0.3)",
    shadowBorderCardHover: "0 0 0 2px rgba(116,39,248)",
    shadowBorderCardOnboarding: "0 0 0 1px rgba(20,136,17,1)",
    shadowBorderCardDefault: "0 0 0 1px #414045",
    shadowBorderStepActive: "0 0 0 4px rgba(175,128,244,0.3)",
    shadowBorderAvatarPrivate: "0 0 0 2px rgba(253,245,231,1)",
    shadowBorderAvatarAdmin: "0 0 0 2px #333436",
    shadowInnerCardPressed: "inset 0 2px 2px 0 rgba(0,0,0,0.22)",
    shadowInnerContentTop: "inset 0 4px 4px 0 rgba(0,0,0,0.16)",
    shadowInnerContentBottom: "inset 0 -4px 4px 0 rgba(0,0,0,0.16)",
    shadowInnerContentLeft: "inset 4px 0 4px 0 rgba(0,0,0,0.16)",
    shadowInnerContentRight: "inset -4px 0 4px 0 rgba(0,0,0,0.16)",
    tellentShadowBorderFormFocusDefault: "0 0 0 3px rgba(175,128,244,0.3)",
    tellentShadowBorderCardActive: "0 0 0 4px rgba(175,128,244,0.3)",
    tellentShadowBorderCardHover: "0 0 0 2px rgba(232,51,147,1)",
    kiwiShadowBorderFormFocusDefault: "0 0 0 2px rgba(0,133,62,0.2)",
    kiwiShadowBorderCardActive: "0 0 0 4px rgba(175,128,244,0.3)",
    kiwiShadowBorderCardHover: "0 0 0 2px rgba(0,120,56,1)",
    avatarSteelLighter: "#ad94e0",
    avatarSteelLight: "#313235",
    avatarSteelDark: "#61636b",
    avatarGrayLight: "#414045",
    avatarGrayDark: "#838288",
    avatarGreen: "#4cc99f",
    avatarBlueLight: "#5a9dfc",
    avatarBlueDark: "#bd6bb3",
    avatarBlueDarker: "#dfccfb",
    avatarPink: "#9a4cb6",
    avatarPurple: "#b694f5",
    avatarYellow: "#ed913b",
    avatarOrange: "#db6300",
    avatarSkeleton: "#2e2f33",
    chartBrandDefault: "#8659ca",
    chartSkyDefault: "#f47174",
    chartOceanDefault: "#008ee5",
    chartOrchidDefault: "#e566a5",
    chartLavenderDefault: "#03ad9c",
    chartSteelDefault: "#a6a2af",
    chartEmeraldDefault: "#45c2d1",
    chartMintDefault: "#cd75bc",
    chartCobaltDefault: "#ffd76f",
    chartSunflowerDefault: "#feb07b",
    chartLemonDefault: "#6871ee",
    chartPumpkinDefault: "#b2a1f7",
    candidatesBgBrandDefault: "#8659ca",
    candidatesBgRainforestDefault: "#1a8e68",
    candidatesBgFireDefault: "#c45a03",
    candidatesBgGoldDefault: "#f2b10d",
    candidatesBgJungleDefault: "#2caa86",
    candidatesBgNavyDefault: "#0c6090",
    candidatesBgEggplantDefault: "#512fa2",
    candidatesBgGrassDefault: "#46af0e",
    candidatesBgDenimDefault: "#083f5e",
    candidatesBgLilacDefault: "#8c44a7",
    candidatesBorderBrandDefault: "#8659ca",
    candidatesBorderRainforestDefault: "#1a8e68",
    candidatesBorderFireDefault: "#c45a03",
    candidatesBorderGoldDefault: "#f2b10d",
    candidatesBorderJungleDefault: "#2caa86",
    candidatesBorderNavyDefault: "#0c6090",
    candidatesBorderEggplantDefault: "#512fa2",
    candidatesBorderGrassDefault: "#46af0e",
    candidatesBorderDenimDefault: "#083f5e",
    candidatesBorderLilacDefault: "#8c44a7",
    aiDefault: "linear-gradient(-90deg, #633068 0%, #383262 100%)",
    aiSubduedDefault: "linear-gradient(-90deg, #372C3E 0%, #332D41 100%)",
    aiStrongDefault: "linear-gradient(-90deg, #EDC2E1 0%, #DABFF5 100%)",
    productRecruitee50: "#322447",
    productRecruitee100: "#3d2c56",
    productRecruitee200: "#543680",
    productRecruitee300: "#724ea7",
    productRecruitee400: "#9167cd",
    productRecruitee500: "#af80f4",
    productRecruitee600: "#bf99f6",
    productRecruitee700: "#cfb3f8",
    productRecruitee800: "#dfccfb",
    productRecruitee900: "#e7d9fc",
    productKiwi50: "#0f2115",
    productKiwi100: "#1a402c",
    productKiwi200: "#1e422b",
    productKiwi300: "#2e6240",
    productKiwi400: "#3d8356",
    productKiwi500: "#00853e",
    productKiwi600: "#009e4a",
    productKiwi700: "#00b856",
    productKiwi800: "#00d162",
    productKiwi900: "#00eb6d",
    productJavelo50: "#2a0f01",
    productJavelo100: "#5f240b",
    productJavelo200: "#541d02",
    productJavelo300: "#7d2c03",
    productJavelo400: "#a73a04",
    productJavelo500: "#d14905",
    productJavelo600: "#da6931",
    productJavelo700: "#e38a5d",
    productJavelo800: "#ecaa89",
    productJavelo900: "#f0ba9f",
    productTellent50: "#260016",
    productTellent100: "#420027",
    productTellent200: "#5e0b37",
    productTellent300: "#951b5c",
    productTellent400: "#cc287f",
    productTellent500: "#e83393",
    productTellent600: "#ec53a4",
    productTellent700: "#ef73b5",
    productTellent800: "#f6b3d7",
    productTellent900: "#fce3f0",
    onboardingBackgroundDefault: "#543680",
    onboardingBackgroundLoader: "#4f4f4f",
    onboardingBackgroundLow: "#35373b",
    onboardingBackgroundSubdued: "#452334",
    onboardingTextDefault: "#ffffff",
    onboardingTextLow: "#cfb3f8",
    onboardingIconDefault: "#fd62b0",
    onboardingIconLow: "#cfb3f8",
    articleOceanDefault: "#009199",
    articleOceanSubduedDefault: "#003a3d",
    articleOrchidDefault: "#863eda",
    articleOrchidSubduedDefault: "#3c156b",
    billingPink: "#f65978",
    billingPinkLight: "#ffedf5",
    billingOrange: "#ffaa45",
    billingOrangeLight: "#fff3e5",
    billingBlue: "#61a5ff",
    billingBlueLight: "#e9f3ff",
    billingTurquoise: "#34d0d7",
    billingTurquoiseLight: "#ebfafb",
    billingPurple: "#c746cb",
    billingPurpleLight: "#f7e6f8",
    billingNavy: "#0e0bc7",
    billingNavyLight: "#e6e6f4",
    billingGreen: "#56d586",
    billingGreenLight: "#e8f9ee",
    buttonPrimaryShadowDefault: "0 2px 5px 0 rgba(0,0,0,0.10), 0 1px 2px 0 rgba(0,0,0,0.10)",
};
